/**
 * StreakBadge — small flame indicator for the header.
 * Hidden if user has no active streak.
 */
import { Flame } from "lucide-react";
import { Link } from "react-router-dom";
import { useStreak } from "@/lib/streaks/useStreak";

const StreakBadge = () => {
  const { streak } = useStreak();
  if (!streak || streak.current < 1) return null;

  return (
    <Link
      to="/account"
      title={`${streak.current}-day streak · longest ${streak.longest}`}
      className="inline-flex items-center gap-1.5 rounded-full border border-border bg-secondary/60 px-2.5 py-1 text-xs font-medium text-foreground hover:bg-secondary transition-colors"
    >
      <Flame className="h-3.5 w-3.5 text-primary" aria-hidden />
      <span>{streak.current}</span>
    </Link>
  );
};

export default StreakBadge;
